import { Component } from '@angular/core';

@Component({
  selector: 'app-server-error',
  templateUrl: './server-error.component.html',
  styleUrls: ['../not-authorized/not-authorized.component.css']
})
export class ServerErrorComponent {

}
